<div id="home-upcoming-irrigation">
  @if (hasIrrigationProgramAccess) {
    @if (!upcomingIrrigationLoading) {
      @if (!fetchingError) {
        @if (selectablePlantationsForUpcomingIrrigation?.length > 0) {
        <div class="header">
          <span class="title">
            {{ 'doktar_app.home.upcoming_irrigation' | translate }}
          </span>
        </div>
        <div class="content">
          <div class="plantation-selection">
            <span class="information">
              {{ 'doktar_app.home.showing_dates_for' | translate }}
            </span>
            <div class="select-box">
              <dk-home-plantation-select
                #upcomingIrrigationSelect
                [selectablePlantations]="selectablePlantationsForUpcomingIrrigation"
                [selectedPlantation]="selectedPlantationForUpcomingIrrigation"
                (onSelectPlantation)="onSelectPlantationForUpcomingIrrigation($event)"></dk-home-plantation-select>
            </div>
          </div>
          <div class="irrigation-items">
            @for (
              item of selectedPlantationRecommendations;
              track item.plantationId + (item.recommendedDate?.toISODate() ?? '') + item.recommendedAmount + $index
            ) {
              <div class="irrigation-item">
                <div class="irrigation-item-content">
                  <div class="date">
                    <span class="content-title">{{ 'doktar_app.common.date' | translate }}</span>
                    <span class="content-desc">
                      {{ item.recommendedDate | luxonFormat: 'dd MMM, yyyy' }}
                    </span>
                  </div>
                  <div class="amount">
                    <span class="content-title">{{ 'doktar_app.common.amount' | translate }}</span>
                    <span class="content-desc">
                      <span class="amount-value">{{ item.recommendedAmount?.toFixed(2) }} </span>
                      <span class="amount-unit">{{ item.amountUnit || 'mm' }}</span>
                    </span>
                  </div>
                </div>
                <dk-button
                  [icon]="'ph ph-arrow-right'"
                  severity="secondary"
                  size="medium"
                  (onClick)="goToIrrigation()"></dk-button>
              </div>
            }
          </div>
        </div>
        } @else {
          <div class="header">
            <span class="title">
              {{ 'doktar_app.home.upcoming_irrigation' | translate }}
            </span>
          </div>
          <div class="create-irrigation-container">
            <div class="content">
              <i class="ph ph-calendar"></i>
              <span class="title">{{'doktar_app.home.irrigation_programs.add_program_title' | translate}}</span>
              <span class="description">{{'doktar_app.home.irrigation_programs.add_program_description' | translate}}</span>
            </div>
            <div class="actions">
              <dk-button
                severity="primary"
                [icon]="'ph ph-plus'"
                [text]="true"
                (onClick)="goToIrrigation()"
              ></dk-button>
            </div>
          </div>
        }
      } @else {
        <widget-info-box
          [isErrorState]="true"
          [title]="'doktar_app.home.warnings.not_load_upcoming_irrigation_title' | translate"
          [description]="
            'doktar_app.home.warnings.not_load_upcoming_irrigation_description'
              | translate
          "
          (primaryButtonClick)="getUpcomingIrrigationPlantations()" />
      }
    } @else {
      <div class="mt-3">
        <p-skeleton width="100%" height="4rem" styleClass="mb-3" />
        <p-skeleton width="100%" height="4rem" />
      </div>
    }
  } @else {
    <div class="upcoming-irrigation-no-premium">
      <div class="icon-container">
        <i class="ph-fill ph-drop"></i>
      </div>
      <div class="content">
        <span class="title">{{ 'doktar_app.home.irrigation_purchase_title' | translate }}</span>
        <span class="description">{{ 'doktar_app.home.irrigation_purchase_description' | translate }}</span>
      </div>
      <div class="actions">
        <dk-button
          [label]="'doktar_app.common.get_premium' | translate"
          severity="primary"
          (onClick)="getPremiumEvent.emit()"></dk-button>
      </div>
    </div>
  }
</div>
